// Helper function to extract volume number from volume string
export const getVolumeNumber = (volume = '') => {
  if (!volume || typeof volume !== 'string') return 'No_Volume';
  const match = volume.match(/\d+/);
  return match ? parseInt(match[0], 10) : 'No_Volume';
};

// Helper function to extract prefix from volume string
export const getVolumePrefix = (volume = '') => {
  if (!volume || typeof volume !== 'string') return '';
  const match = volume.match(/^([^0-9]*)/);
  return match ? match[1].trim() : '';
};

// Helper function to get next expected volume number
export const getNextVolumeNumber = (existingVolumes = []) => {
  if (!existingVolumes.length) return 1;

  const numbers = existingVolumes
    .map((vol) => getVolumeNumber(vol))
    .filter((num) => num !== 'No_Volume')
    .sort((a, b) => a - b);

  if (!numbers.length) return 1;

  // Find the first gap in sequence or return next number
  for (let i = 1; i <= numbers[numbers.length - 1] + 1; i++) {
    if (!numbers.includes(i)) {
      return i;
    }
  }

  return numbers[numbers.length - 1] + 1;
};

// Helper function to get copy number for new item in volume - FIXED
export const getNextCopyNumberForVolume = (fields, volume) => {
  if (!fields?.value) return 1;

  const volumeItems = fields.value.filter(
    (item) => (item.volume || 'No_Volume') === volume,
  );

  if (!volumeItems.length) return 1;

  const copyNumbers = volumeItems
    .map((item) => parseInt(item.copyNumber, 10) || 0)
    .filter((num) => !Number.isNaN(num))
    .sort((a, b) => a - b);

  if (!copyNumbers.length) return 1;

  // Find the first gap in sequence or return next number
  for (let i = 1; i <= copyNumbers[copyNumbers.length - 1] + 1; i++) {
    if (!copyNumbers.includes(i)) {
      return i;
    }
  }

  return copyNumbers[copyNumbers.length - 1] + 1;
};

// Function to recalculate copy numbers for a specific volume - NEW
export const recalculateCopyNumbers = (fields, volume) => {
  if (!fields?.value) return;

  const fieldsArray = fields.value;
  const volumeItems = fieldsArray
    .map((item, index) => ({ item, index }))
    .filter(({ item }) => (item.volume || 'No_Volume') === volume)
    .sort((a, b) => a.index - b.index); // Keep original order

  volumeItems.forEach(({ item, index }, copyIndex) => {
    const newCopyNumber = copyIndex + 1;
    if (item.copyNumber !== newCopyNumber) {
      fields.update(index, {
        ...item,
        copyNumber: newCopyNumber,
      });
    }
  });
};

// Helper function to get existing volumes from fields
export const getExistingVolumes = (fields, shouldGroupByVolumes) => {
  if (!shouldGroupByVolumes) return [];
  const fieldsArray = fields?.value || [];
  if (!fieldsArray.length) return [];

  const volumes = fieldsArray
    .map((item) => item.volume)
    .filter((vol) => vol && vol !== 'No_Volume');
  return [...new Set(volumes)];
};

// Helper function to get volume items count
export const getVolumeItemsCount = (fields, volume) => {
  if (!fields?.value) return 0;
  return fields.value.filter((item) => (item.volume || 'No_Volume') === volume)
    .length;
};

// Helper function to validate volume string
export const isValidVolumeString = (volumeString) => {
  if (!volumeString || typeof volumeString !== 'string') return false;
  return volumeString.trim().length > 0;
};

// Helper function to create full volume string
export const createVolumeString = (prefix, number) => {
  if (!prefix || !number) return '';
  return `${prefix}${number}`;
};

// Helper function to check if volume exists
export const volumeExists = (volumeString, existingVolumes) => {
  return existingVolumes.includes(volumeString);
};
